<template>
  <div class="app-container course-courseware-post-detail">
    <el-button
      icon="el-icon-arrow-left"
      @click="goBack"
      class="back-button"
      type="text">
    </el-button>
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="detail">
          <el-row class="course-courseware-post-detail-item">
            <el-col :span="3">标题:</el-col>
            <el-col :span="16">{{ (postDetail.title || postDetail.titleEn) | formatDefaultlVal }}</el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item" >
            <el-col :span="3">内容素材:</el-col>
            <el-col :span="16">
              <div class="course-courseware-post-cover-image" v-viewer>
                <img v-for="src in postDetail.photos" :src="src" :key="src">
              </div>
            </el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item course-courseware-post-content-text">
            <el-col :span="3">正文:</el-col>
            <el-col :span="16">
              <div v-if="postDetail.contentType == 1">
                <div v-html="postDetail.content"></div>
              </div>
              <div v-else>{{ (postDetail.content ? postDetail.content : postDetail.contentEn) | formatDefaultlVal }}</div>
            </el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item">
            <el-col :span="3">发布者员工号:</el-col>
            <el-col :span="16">
              {{ postDetail.postedByUnionId }}
            </el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item">
            <el-col :span="3">发布者Full Name:</el-col>
            <el-col :span="16">
              {{ postDetail.postedByName }}
            </el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item">
            <el-col :span="3">内容状态:</el-col>
            <el-col :span="16">{{ postDetail.isBanned ? "已下架" : "已发布" }}</el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item">
            <el-col :span="3">下架原因:</el-col>
            <el-col :span="16">{{ postDetail.banComment | formatDefaultlVal }}</el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item">
            <el-col :span="3">发布时间:</el-col>
            <el-col :span="16">{{ postDetail.postTime | formatDefaultlVal }}</el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item">
            <el-col :span="3">评论量:</el-col>
            <el-col :span="16">
              {{ postDetail.commentCount }}
            </el-col>
          </el-row>
          <el-row class="course-courseware-post-detail-item">
            <el-col :span="3">点赞量:</el-col>
            <el-col :span="16">{{postDetail.likeCount}}</el-col>
          </el-row>
          <el-dialog :visible.sync="unhandledVideolsVisible" width="40%" class="handle-dialog" @close="closeVideo">
            <video-player
              class="vjs-mc-skin"
              :playsinline="true"
              :options="postDetail.playerOption"
              ref="videoPlayer">
            </video-player>
          </el-dialog>
        </el-tab-pane>

        <el-tab-pane label="评论列表" name="comment">
          <el-table :data="courseCoursewareCommentData" stripe tooltip-effect="dark">
            <el-table-column prop="content" label="评论内容" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="commentByName" label="评论人Full Name" width="140"></el-table-column>
            <el-table-column align="center" prop="commentByRealname" label="评论人Birth Name" width="140"></el-table-column>
            <el-table-column align="center" prop="commentTime" label="评论时间" width="200"></el-table-column>
            <el-table-column align="center" prop="commentToName" label="回复对象Full Name" width="160"></el-table-column>
            <el-table-column align="center" prop="commentToRealname" label="回复对象Birth Name" width="160"></el-table-column>
            <el-table-column align="center" label="是否已下架" width="100">
              <template slot-scope="scope">
                {{scope.row.isBanned ? "是" : "否"}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="下架原因"  width="200" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.banComment || "--"}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini"
                  type="text"
                  icon="el-icon-upload2"
                  title="上架"
                  v-if="scope.row.isBanned"
                  @click="handleUp(scope.row,scope.index)">上架
                </el-button>
                <el-button size="mini"
                      type="text"
                      icon="el-icon-download"
                      title="下架"
                      v-if="!scope.row.isBanned"
                      @click="handleDown(scope.row,scope.index)">下架
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :page-size="courseCoursewareCommentPage.pageSize"
                         :page-sizes="courseCoursewareCommentPage.pageSizes"
                         :current-page="courseCoursewareCommentPage.currentPage"
                         :total="courseCoursewareCommentPage.total"
                         :layout="courseCoursewareCommentPage.layout"
                         @current-change="courseCoursewareCommentCurrentChange"
                         @size-change="courseCoursewareCommentSizeChange">
          </el-pagination>
        </el-tab-pane>

        <el-tab-pane label="点赞列表" name="like">
          <el-table :data="coursewareCommentLikeData" stripe
            style="width:90%" tooltip-effect="dark">
            <el-table-column align="center" prop="likeTime" label="点赞时间" width="200"></el-table-column>
            <el-table-column align="center" prop="nickname" label="点赞用户Full Name"></el-table-column>
            <el-table-column align="center" prop="realname" label="点赞用户Birth Name"></el-table-column>
          </el-table>
          <el-pagination :page-size="coursewareCommentLikePage.pageSize"
                         :page-sizes="coursewareCommentLikePage.pageSizes"
                         :current-page="coursewareCommentLikePage.currentPage"
                         :total="coursewareCommentLikePage.total"
                         :layout="coursewareCommentLikePage.layout"
                         @current-change="coursewareCommentLikeCurrentChange"
                         @size-change="coursewareCommentLikeSizeChange">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>

    </basic-container>
    <el-dialog
      title="下架"
      :visible.sync="banDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="down-dialog-item-label">下架原因</el-label>
          <el-input v-model="banDialogComment"></el-input>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="banDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDownSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAttachment } from '@/api/admin/complaints';
import { getCoursewarePost, updateCommentStatus } from '@/api/app/course';
import courseCoursewareCommentList  from '@/mixins/course/comment-list';
import courseCoursewareCommentLikeList  from '@/mixins/course/like-list';

export default {
  mixins: [courseCoursewareCommentLikeList, courseCoursewareCommentList],
  data() {
    return {
      id: 0,
      targetType: 0,
      activeName: "detail",
      courseCoursewareId: 0,
      postDetail:{
        id: undefined,
        titleEn: "",
        contentType: undefined,
        content: "",
        contentEn: "",
        postedBy: undefined,
        postedByName: "",
        postedByUnionId: "",
        status: "",
        commentCount: 0,
        favoriteCount: 0,
        postTime: "",
        banComment: "",
      },
      isBindDownloadEvent: false,
      unhandledThumbnailsVisible: false,
      unhandledVideolsVisible: false,
      thumbnails: undefined,
      banDialogVisible: false,
      banDialogComment: "",
      banDialogIsSendWx: false,
      banDialogSendWxMessage: "",
      banDialogRow: 0,
    }
  },
  async mounted() {
    this.courseCoursewareId = this.$route.query.id;
    await this.initDetail(this.$route.params.id)
  },
  filters: {
    formatDefaultlVal(val) {
      return !!val ? val : '--';
    },
  },
  methods: {
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    onTabShow(tab) {
      switch (tab.name) {
        case 'detail':
          this.initDetail(this.$route.params.id);
          break;
        case 'comment':
          this.initCourseCoursewareComment();
          break;
        case 'like':
          this.initCoursewareCommentLike();
          break;
      }
    },
    thumbnailDetail(handleResult, id) {
      this.unhandledThumbnailsVisible = handleResult !== 0
      getAttachment(id).then(response => {
        this.thumbnails = response.data.data
      })
    },
    async initDetail(id) {
      const response = await getCoursewarePost(id);
      if (response.status == 200) {
        this.formatPostDetail(response.data.data);
      } else {
        this.$message({
          showClose: true,
          message: '无法查看该帖子详情',
          type: 'error'
        });
      }
    },
    formatPostDetail(data) {
      this.id = data.id;
      this.postDetail.id = data.id
      this.postId = data.id
      this.postDetail.title = data.title;
      this.postDetail.titleEn = data.titleEn;
      this.postDetail.content = data.content;
      this.postDetail.contentEn = data.contentEn;
      if (!data.postedBy) {
        this.postDetail.postedByName = "--" ;
        this.postDetail.postedByUnionId = "--";
      } else {
        this.postDetail.postedByName = data.postedBy.name ? data.postedBy.name : "--" ;
        this.postDetail.postedByUnionId = data.postedBy.unionId ? data.postedBy.unionId : "--";
      }

      if (!data.commentCount) this.postDetail.commentCount = 0;
      else this.postDetail.commentCount = data.commentCount;

      this.postDetail.favoriteCount = data.favoriteCount || 0;
      this.postDetail.likeCount = data.likeCount || 0;
      this.postDetail.postTime = data.postTime;
      this.postDetail.isBanned = data.isBanned;
      this.postDetail.banComment = "--";
      if (data.isBanned) {
        this.postDetail.banComment = data.banComment;
      }

      if (data.attachments && data.attachments[0]) {
        this.postDetail.photos = data.attachments.map(item => { return item.thumbnailUrl });
      }
    },
    handleUp(row, index) {
      // 上架功能
      let _this = this
      this.$confirm('是否确认上架内容为"' + row.content + '"'+ '的评论?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return updateCommentStatus(row.id, null);
      }).then(() => {
        this.initCourseCoursewareComment()
        _this.$message({
          showClose: true,
          message: '上架成功',
          type: 'success'
        })
      }).catch(function () {
      })
    },
    handleDown(row, index) {
      this.banDialogRow = row;
      this.banDialogComment = "";
      this.banDialogIsSendWx = false;
      this.banDialogSendWxMessage = "你发布的评论未能通过审核，请重新发布内容";
      this.banDialogVisible = true;
    },
    handleDownSubmit() {
      if (!this.banDialogComment) {
        this.$message({
          showClose: true,
          message: '下架原因不能为空',
          type: 'error'
        });
        return;
      }

      if (this.banDialogIsSendWx && !this.banDialogSendWxMessage) {
        this.$message({
          showClose: true,
          message: '发送消息不能为空',
          type: 'error'
        });
        return;
      }
      let coursewareCommentDTO = {
        banComment: this.banDialogComment,
        isSendWxMessage: this.banDialogIsSendWx,
        wxMessage: this.banDialogSendWxMessage,
      }
      updateCommentStatus(this.banDialogRow.id, coursewareCommentDTO)
        .then(response => {
          this.initCourseCoursewareComment();
          this.$message({
            showClose: true,
            type: 'success',
            message: '下架成功'
          });
        })
        .catch(function (err) {})
        .finally(() => {
          this.banDialogVisible = false;
        });
    },
    goBack() {
      this.$router.push({ 
        path: `/app/course/course-courseware/${this.courseCoursewareId}`, 
      });
    },
  },
}
</script>

<style lang="scss" scoped>

.course-courseware-post-detail {
  .course-courseware-post-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      color: #409EFF;
      text-align: center;
    }
    .list-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
    .handle-dialog {
      display: flex;
      flex-direction: column;
      &-item {
        width: 500px;
        display: flex;
        margin-top: 20px;
        flex-direction: row;
        &-label {
          text-align: center;
          font-size: 14px;
          width: 110px;
          line-height: 36px;
          padding: 0 5px;
        }
        &-input {
          font-size: 14px;
          width: 300px;
          height: 36px;
        }
      }
      &-footer{
        display: flex;
        flex-direction: row;
        padding: 20px 0px;
        &-save {
          padding: 8px 12px;
          position: absolute;
          right: 90px;
        }
        &-cancel {
          padding: 8px 12px;
          position: absolute;
          right: 10px;
          margin-right: 10px;
        }
      }
      &-img {
        max-width: 500px;
      }
    }
  }
  &-item-picture-right {
    font-size: 16px;
    display: table-cell;
    &-item {
      display: inline-block;
      margin-right: 5px;
      margin-top: 5px;
    }
    &-poster {
      position: relative;
      &-icon {
        position: absolute;
        color: #ffffff;
        top: 30px;
        left: 30px;
        font-size: 40px;
      }
      &-icon:hover {
        color: rgba(249, 129, 55, 0.9);
      }
    }
  }
}

.vue-poll .ans-cnt .ans .bg{
  position: absolute;
  width: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #409eff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.course-courseware-post-cover-image {
  display: flex;
  width: fit-content;
  flex-wrap: wrap;
  cursor: pointer;
  img {
    padding: 5px;
    width: 52px;
    height: 52px;
    object-fit: cover;
    max-width: 100%;
  }
}

.course-courseware-post-content-video {
  display: flex;
  width: fit-content;
  padding: 10px;
  cursor: pointer;
  img {
    width: 356px;
    height: 200px;
    object-fit: cover;
    max-width: 100%;
  }
}

.course-courseware-post-content {
  border: 1px solid #eee;
  padding: 10px;
  /deep/ .mc-img {
    max-width: 100%;
  }
  /deep/ a {
    color: #105b89;
    text-decoration: underline;
  }
  /deep/ p {
    color: #000000;
  }
  /deep/ .mc-file {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    padding: 3px;
    line-height: 20px;
    text-decoration: none;
    color: #01396B;
  }
  /deep/ table {
    margin: 1em 0;
  }
}

.complaint {
  .list-button {
    color: #409EFF;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
  }
  .handle-dialog {
    display: flex;
    flex-direction: column;
    &-item {
      width: 500px;
      display: flex;
      margin-top: 20px;
      flex-direction: row;
      &-label {
        text-align: center;
        font-size: 14px;
        width: 110px;
        line-height: 36px;
        padding: 0 5px;
      }
      &-input {
        font-size: 14px;
        width: 300px;
        height: 36px;
      }
    }
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 20px 0px;
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
    &-img {
      max-width: 500px;
    }
  }
}

.course-courseware-post-content-text {
  word-break: break-all;
}

.mc-img {
  max-width: 100%;
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
.back-button {
  position: fixed;
  top: 77px;
  font-size: 16px;
  color: #3B3B3B;
  cursor: pointer;
}
</style>
